import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';

/* Modules */
import { AppCommonModule } from '@common/app-common.module';
import { NavigationModule } from '@modules/navigation/navigation.module';

/* Components */
import * as customTableComponents from './components';

/* Containers */
import * as customTableContainers from './containers';

/* Directives */
import * as customTableDirectives from './directives';

/* Guards */
import * as customTableGuards from './guards';

/* Services */
import * as customTableServices from './services';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        DragDropModule,
        CheckBoxModule,
        DropDownListModule,
        AppCommonModule,
        NavigationModule,
    ],
    providers: [...customTableServices.services, ...customTableGuards.guards],
    declarations: [
        ...customTableContainers.containers,
        ...customTableComponents.components,
        ...customTableDirectives.directives,
    ],
    exports: [
        ...customTableContainers.containers,
        ...customTableComponents.components,
        ...customTableDirectives.directives,
    ],
})
export class CustomTableModule {}
